import PreviewGame from './PreviewGame'
export default PreviewGame